import React, { useState, useEffect } from "react";

// react-router components
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  BrowserRouter,
  redirect,
} from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Material Dashboard 2 React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Material Dashboard 2 React routes
import routes from "routes";

// Material Dashboard 2 React contexts
import {
  useMaterialUIController,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

// Images
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import Dashboard from "layouts/dashboard";

import Signin from "Auth/Signin";

import AddNewTestimonial from "AddViews/AddTestimonials";
import UpdateTestimonials from "UpdateViews/UpdateTestimonials";
import AddCareer from "AddViews/AddCareer";
import UpdateCareer from "UpdateViews/UpdateCareer";

import AddBlogs from "AddViews/AddBlogs";
import ProtectedRoute from "./ProtectedRoute";

import AddNotifications from "AddViews/AddNotifications";

import AddBlogCategory from "AddViews/AddBlogCategories";
import UpdateBlogCategory from "UpdateViews/UpdateBlogCategories";
import UpdateBlogs from "UpdateViews/UpdateBlogs";
import AddAlumini from "AddViews/AddAlumini";
import UpdateAlumini from "UpdateViews/UpdateAlumini";
import AddEvents from "AddViews/AddEvents";
import UpdateEvents from "UpdateViews/UpdateEvents";
import AddGallery from "AddViews/AddGallery";
import AddCourses from "AddViews/AddCourses";
import UpdateCourses from "UpdateViews/UpdateCourses";
import AddSocialMedia from "AddViews/AddSocialMedia";
import UpdateSocialMedia from "UpdateViews/UpdateSocialMedia";
import AddBanner from "AddViews/AddBanner";
import UpdateBanner from "UpdateViews/UpdateBanner";
import AddExams from "AddViews/AddExams";
import UpdateExams from "UpdateViews/UpdateExams";
import AddCount from "AddViews/AddAboutCount";
import UpdateCount from "UpdateViews/UpdateAboutCount";
import AddTeam from "AddViews/AddTeams";
import UpdateTeam from "UpdateViews/UpdateTeams";
import AddFaq from "AddViews/AddFaq";
import UpdateFaq from "UpdateViews/UpdateFaq";
import AddAmenity from "AddViews/AddAmenities";
import UpdateAmenity from "UpdateViews/UpdateAmenities";
import AddNavbarText from "AddViews/AddNavbarText";
import UpdateNavbarText from "UpdateViews/UpdateNavbarText";
import AddProject from "AddViews/AddProjects";
import UpdateProjects from "UpdateViews/UpdateProject";
import AddProduct from "AddViews/AddProducts";
import UpdateProduct from "UpdateViews/UpdateProduct";

export default function Main() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);

  // const admin = JSON.parse(localStorage.getItem("admin_details"));

  // Open sidenav when mouse enter on mini
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      // console.log(admin);

      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  const configsButton = (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.25rem"
      height="3.25rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="small" color="inherit">
        settings
      </Icon>
    </MDBox>
  );
  return (
    <div>
      <Sidenav
        color={sidenavColor}
        brand={
          (transparentSidenav && !darkMode) || whiteSidenav
            ? brandDark
            : brandWhite
        }
        brandName="Fabinov8"
        routes={routes}
        onMouseEnter={handleOnMouseEnter}
        onMouseLeave={handleOnMouseLeave}
      />
      <Configurator />
      {configsButton}
      <Routes>
        {/* <Route path="/" element={<Dashboard />} /> */}
        {getRoutes(routes)}

        <Route
          path="/addtestimonials"
          element={
            <ProtectedRoute
              element={<AddNewTestimonial />}
              allowedRoles={["superadmin"]}
            />
          }
        />
        <Route
          path="/updateTestimonial/:id"
          element={
            <ProtectedRoute
              element={<UpdateTestimonials />}
              allowedRoles={["superadmin"]}
            />
          }
        />
        <Route
          path="/addsubject"
          element={
            <ProtectedRoute
              element={<AddCareer />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updatesubject/:id"
          element={
            <ProtectedRoute
              element={<UpdateCareer />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addBlogCategory"
          element={
            <ProtectedRoute
              element={<AddBlogCategory />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/updateBlogCategory/:id"
          element={
            <ProtectedRoute
              element={<UpdateBlogCategory />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/addnewblogs"
          element={
            <ProtectedRoute
              element={<AddBlogs />}
              allowedRoles={["superadmin", "marketing_team"]}
            />
          }
        />
        <Route
          path="/updateblogs/:id"
          element={
            <ProtectedRoute
              element={<UpdateBlogs />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addNewProject"
          element={
            <ProtectedRoute
              element={<AddProject />}
              allowedRoles={["superadmin", "marketing_team"]}
            />
          }
        />
        <Route
          path="/updateproject/*"
          element={
            <ProtectedRoute
              element={<UpdateProjects />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addNewProduct"
          element={
            <ProtectedRoute
              element={<AddProduct />}
              allowedRoles={["superadmin", "marketing_team"]}
            />
          }
        />
        <Route
          path="/updateproduct/*"
          element={
            <ProtectedRoute
              element={<UpdateProduct />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addalumini"
          element={
            <ProtectedRoute
              element={<AddAlumini />}
              allowedRoles={["superadmin", "marketing_team"]}
            />
          }
        />
        <Route
          path="/updateAlumini/:id"
          element={
            <ProtectedRoute
              element={<UpdateAlumini />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addevent"
          element={
            <ProtectedRoute
              element={<AddEvents />}
              allowedRoles={["superadmin", "marketing_team"]}
            />
          }
        />
        <Route
          path="/updateEvent/:id"
          element={
            <ProtectedRoute
              element={<UpdateEvents />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/addgallery"
          element={
            <ProtectedRoute
              element={<AddGallery />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/addcourses"
          element={
            <ProtectedRoute
              element={<AddCourses />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updatecourses/:id"
          element={
            <ProtectedRoute
              element={<UpdateCourses />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addSocialMedia"
          element={
            <ProtectedRoute
              element={<AddSocialMedia />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updateSocialMedia/:id"
          element={
            <ProtectedRoute
              element={<UpdateSocialMedia />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addBanner"
          element={
            <ProtectedRoute
              element={<AddBanner />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updateBanner/:id"
          element={
            <ProtectedRoute
              element={<UpdateBanner />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addexams"
          element={
            <ProtectedRoute
              element={<AddExams />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updateExams/:id"
          element={
            <ProtectedRoute
              element={<UpdateExams />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addcount"
          element={
            <ProtectedRoute
              element={<AddCount />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updateCount/:id"
          element={
            <ProtectedRoute
              element={<UpdateCount />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addteam"
          element={
            <ProtectedRoute
              element={<AddTeam />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updateteam/:id"
          element={
            <ProtectedRoute
              element={<UpdateTeam />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addfaq"
          element={
            <ProtectedRoute
              element={<AddFaq />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updatefaq/:id"
          element={
            <ProtectedRoute
              element={<UpdateFaq />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addAmenity"
          element={
            <ProtectedRoute
              element={<AddAmenity />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updateAmenity/:id"
          element={
            <ProtectedRoute
              element={<UpdateAmenity />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addnavbartext"
          element={
            <ProtectedRoute
              element={<AddNavbarText />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updatenavbartext/:id"
          element={
            <ProtectedRoute
              element={<UpdateNavbarText />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />

        <Route
          path="/addNotification"
          element={
            <ProtectedRoute
              element={<AddNotifications />}
              allowedRoles={["superadmin"]}
            />
          }
        />
      </Routes>
    </div>
  );
}
